import styled from 'styled-components'

import { BaseButtonStyled } from '@ui/elements/Button/styles/BaseButtonStyled'
import { boxShadow } from '@ui/utils/boxShadow'

interface IButtonGroupStyledProps {}

export const ButtonGroupStyled = styled.div<IButtonGroupStyledProps>`
  display: inline-flex;

  > ${/* sc-selector */ BaseButtonStyled} {
    margin: 0;
    /* stylelint-disable-next-line */
    margin-left: -1px;

    border-radius: 0;
    box-shadow: none;
    min-width: auto;

    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  ${boxShadow()}
`
